export default "__VITE_ASSET__BWtAySyL__"